<template>
  <v-row class="mt-1">
    <v-col cols="12" >
      <h1 class="subtitle-1 text-left white--text font-weight-light">
        <v-icon size="16" color="white" class="mr-1">{{icon}}</v-icon>
        {{title}}
      </h1>
      <v-divider dark class="mb-1"></v-divider>
    </v-col>
  </v-row>

</template>

<script>
    export default {
        props:['title', 'icon']
    }
</script>
